import React from 'react';
import { useSelector } from 'react-redux';
import history from '~/services/history';

import VendasIcon from '~/assets/img/grid/vendas.svg';
import SimuladorIcon from '~/assets/img/grid/simulador.svg';
import HandsIcon from '~/assets/img/grid/hand.svg';

import { Text } from '../../../../../../components/Text';
import { BlockBotao, Container, Circle, ButtonListArea } from './styles';

export function BotaoGrid() {
	const { user } = useSelector((state) => state.auth);
	const handleTransacoes = (nome) => {
		history.push({
			pathname: `/client/transacoes`,
			state: { type_movement: nome },
		});
	};

	return (
		<Container>
			<ButtonListArea>
				{user.dados.permissoes.view_vendas &&
					<BlockBotao onClick={() => handleTransacoes('vendas')}>
						<Circle>
							<img src={VendasIcon} alt="Vendas" />
						</Circle>
						<Text color="softBlack" size="small" position="below">
							Vendas
						</Text>
					</BlockBotao>
				}
				{user.dados.permissoes.view_meus_pedidos &&
					<BlockBotao disabled onClick={() => handleTransacoes('pedidos')}>
						<Circle>
							<img src={HandsIcon} alt="Vendas" />
						</Circle>
						<Text color="softBlack" size="small">
							Meus Pedidos
						</Text>
					</BlockBotao>
				}
				{user.dados.permissoes.view_simulador &&
					<BlockBotao onClick={() => history.push(`/client/simulador`)}>
						<Circle>
							<img src={SimuladorIcon} alt="Vendas" />
						</Circle>
						<Text color="softBlack" size="small">
							Simulador
						</Text>
					</BlockBotao>
				}
			</ButtonListArea>
		</Container>
	);
}
